export default "__VITE_ASSET__30590476__"